import * as React from "react";
import type { SVGProps } from "react";
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#050033" fillOpacity={0.2} clipPath="url(#home_svg__a)">
      <path d="m12 6.306-8.56 7.056q0 .015-.007.045a.2.2 0 0 0-.007.044v7.145q0 .388.282.67a.92.92 0 0 0 .67.284h5.716v-5.717h3.812v5.717h5.716a.92.92 0 0 0 .67-.284.92.92 0 0 0 .283-.67v-7.145a.2.2 0 0 0-.015-.089z" />
      <path d="m23.834 11.754-3.26-2.709V2.971a.46.46 0 0 0-.134-.342.46.46 0 0 0-.342-.134H17.24a.47.47 0 0 0-.343.134.46.46 0 0 0-.133.342v2.903l-3.632-3.037A1.74 1.74 0 0 0 12 2.45q-.654 0-1.131.387L.165 11.754a.43.43 0 0 0-.163.32q-.015.201.104.35l.923 1.102q.12.134.312.164.18.015.358-.104L12 4.996l10.301 8.59a.46.46 0 0 0 .313.103h.045a.5.5 0 0 0 .312-.163l.923-1.102q.12-.15.104-.35a.43.43 0 0 0-.164-.32" />
    </g>
    <defs>
      <clipPath id="home_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHome;
